import type { WorkflowEventType } from './dossier';
import type { NotificationDto } from './dto';

/**
 * socket.io path on the API origin. It sits under `/api/` so the reverse-proxy rule that already forwards the API
 * (and the Vite dev proxy) covers it; the proxy must pass WebSocket upgrades through.
 */
export const REALTIME_PATH = '/api/v1/socket.io';

/**
 * A document request or one of its tasks changed. Only ids travel over the socket: clients refetch through the REST
 * API, which applies the usual permissions.
 */
export interface DrChangedEvent {
  requestId: string;
  workItemId: string | null;
  type: WorkflowEventType;
}

/** Events the API pushes to signed-in browsers. */
export interface RealtimeServerEvents {
  /** A notification was just created for the connected user. */
  'notification:new': (notification: NotificationDto) => void;
  /** Sent to coordinators (RA, MIS, admins) and to the people with a task on the request. */
  'dr:changed': (event: DrChangedEvent) => void;
}

/** Browsers never send events; the socket is push-only. */
export type RealtimeClientEvents = Record<string, never>;
